<template>
  <div class="d-flex home justify-content-center general">
    <Dashaboard v-if="isAdmin" />
    <main v-else class="dashboard-access" aria-labelledby="dashboard-access-title">
      <section class="dashboard-access__card" role="status">
        <div class="dashboard-access__icon" aria-hidden="true">
          <b-icon-shield-lock />
        </div>
        <span class="dashboard-access__eyebrow">Dashboard</span>
        <h1 id="dashboard-access-title">
          Informações disponíveis apenas para administradores
        </h1>
        <p>
          Os indicadores e valores gerenciais desta página são restritos ao perfil de
          administrador.
        </p>
        <div class="dashboard-access__note">
          <b-icon-info-circle />
          <span>Continue acessando as funcionalidades permitidas pelo menu lateral.</span>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import Dashaboard from "../../components/Dashboard/Index-Dashboard.vue";

export default {
  components: {
    Dashaboard,
  },
  data() {
    return {};
  },
  computed: {
    isAdmin() {
      return localStorage.getItem("userLevel") === "adm";
    },
  },
};
</script>
<style scoped>
.general {
  min-height: 100vh;
  background: #f7f4ff;
}

.dashboard-access {
  --access-accent: #6730de;
  --access-soft: #f0eaff;
  width: calc(100% - 60px);
  min-height: 100vh;
  margin-left: 60px;
  padding: 82px 42px 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.dashboard-access__card {
  width: min(100%, 680px);
  padding: 52px 48px;
  border: 1px solid rgba(71, 48, 134, 0.08);
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 22px 54px rgba(31, 28, 92, 0.08);
  text-align: center;
}

.dashboard-access__icon {
  width: 76px;
  height: 76px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: var(--access-accent);
  background: var(--access-soft);
  font-size: 34px;
}

.dashboard-access__eyebrow {
  display: block;
  margin-bottom: 10px;
  color: var(--access-accent);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.dashboard-access h1 {
  margin: 0;
  color: #12105d;
  font-size: clamp(24px, 3vw, 32px);
  line-height: 1.2;
  font-weight: 800;
}

.dashboard-access p {
  max-width: 520px;
  margin: 16px auto 0;
  color: #66638c;
  font-size: 15px;
  line-height: 1.6;
}

.dashboard-access__note {
  max-width: 520px;
  min-height: 48px;
  margin: 24px auto 0;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 10px;
  color: #493587;
  background: var(--access-soft);
  font-size: 13px;
  font-weight: 600;
}

@media screen and (max-width: 745px) {
  .dashboard-access {
    width: 100%;
    min-height: 100vh;
    margin-left: 0;
    padding: 76px 18px 40px;
  }

  .dashboard-access__card {
    padding: 36px 22px;
  }

  .dashboard-access__note {
    align-items: flex-start;
    text-align: left;
  }
}
</style>
